import { Skeleton } from 'antd';
import React from 'react';

function PublicCouponUpsertModalSkeleton() {
  return (
    <div className="space-y-5">
      <Skeleton.Input active size="large" block className="mb-4" />
      <div className="grid grid-cols-2 gap-x-5">
        <Skeleton.Input active size="large" block />
        <Skeleton.Input active size="large" block />
      </div>
      <Skeleton.Input active size="large" block />
      <Skeleton.Input active size="large" block />
      <Skeleton.Input active size="large" block />
      <Skeleton.Button active size="large" block />
      <div className="grid grid-cols-2 gap-x-5">
        <Skeleton.Button active size="large" block />
        <Skeleton.Button active size="large" block />
      </div>
    </div>
  );
}

export default PublicCouponUpsertModalSkeleton;
